import { genericPage, getServerSidePropsHelper } from 'components/corporatiu/Page';
import { useRouter } from 'next/router';
///atencio/com-veure-i-escoltar/
const path = ['web', process.env.FOLDER_LAYOUTS_CORPORATIU, 'atencio', 'com-veure-i-escoltar'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    return getServerSidePropsHelper(context, { slugs: path });
}

export default Pagina;
